/* eslint-disable no-restricted-imports */
import LoyaltyControl from '~/client/features/Loyalty/LoyaltyControl';
import useAgentData from '~/client/hooks/useAgentData';
import ExpandButton from './ExpandButton';
import UserControls from './UserControls';
import WalletButton from './WalletButton';
import GameBody from '../../GameBody';
import BackButton from '../BackButton';
import GameCurrency from '../../GameCurrencySelect/useGameCurrencySelect/GameCurrency';
import { CashierCurrencyType } from '@/graphql/schema';

type Props = {
  onClickBack?: () => void;
  gameCurrencySelect: GameCurrency;
  cashierCurrencyType?: CashierCurrencyType;
  cashierCurrency?: CashierCurrency;
  isLoggedIn: boolean;
};

const GameFrame: FC<Props> = ({
  onClickBack,
  cashierCurrencyType,
  cashierCurrency,
  isLoggedIn,
}) => {
  const { isSafari } = useAgentData();

  return (
    <div className="bg-popo fixed top-0 bottom-0 left-0 right-0 z-40 text-goten flex flex-col">
      <header className="h-14 px-3 flex items-center justify-between">
        <BackButton onClick={onClickBack} />
        <div className="flex gap-2">
          <UserControls isLoggedIn={isLoggedIn}>
            <WalletButton type={cashierCurrencyType} name={cashierCurrency} />
            <LoyaltyControl />
          </UserControls>
          {!isSafari && <ExpandButton />}
        </div>
      </header>
      <GameBody isDesktop={false} />
    </div>
  );
};

export default GameFrame;
